import styled, { css } from 'styled-components';
import colors from '../../../../styles/settings/colors';
import fontSize from '../../../../styles/settings/fontSize';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';

export const DialogModal = styled(Dialog)`
  &.dialog-parent {
    .MuiDialog-paperWidthSm {
      max-width: fit-content;
      ${(props) =>
        !props.htmlText &&
        css`
          width: 500px !important;
          ${(props) =>
            props.widthContainer > 0 &&
            css`
              width: ${props.widthContainer}px;
              max-width: ${props.widthContainer + 0.1}px!important;
            `}
        `}
    }
  }
`;

export const Title = styled(DialogTitle)`
  align-items: center;
  background: ${(props) => props.bgColor || colors.sanMarino};
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: ${(props) => (props.heightTitle ? 0 : '2px 0')}!important;

  h2 {
    color: ${(props) => props.color || '#fff'};
    display: block;
    font-size: ${(props) => (props.fontTitle > 0 ? props.fontTitle : 14)}px;
    font-weight: bold;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    text-align: center;
  }
`;

// export const BodyText = styled(DialogContent)`
//   background: ${(props) => props.bgColor || '#fff'};

//   p {
//     align-items: center;
//     color: ${(props) => props.color || '#000'};
//     display: flex;
//     justify-content: center;
//     text-align: center;
//   }
// `;

export const DialogContainer = styled.div`
  background: ${(props) => props.widhtContainer || 'auto'};
  padding: 8px;
  ${(props) =>
    props.htmlText &&
    css`
      width: fit-content;
  `}
  .margin-container {
    border: 1px solid ${(props) => props.borderColor || colors.sanMarino};

    .MuiDialogTitle-root {
      padding: 2px 0;
    }
  }
`;

export const BodyText = styled(DialogContent)`
  background: ${(props) => props.bgColor || '#fff'};
  height: ${(props) => props.height || '#fff'};
  display: flex;
  justify-content: center;

  p {
    align-items: center;
    color: ${(props) => props.color || '#000'};
    font-size: ${(props) =>
      props.messageFontSize ? `${props.messageFontSize}px` : fontSize.button};
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 0;
  }
`;

export const DialogActionsMessage = styled(DialogActions)`
  background: ${(props) => props.backgroundColor || '#fff'};
  justify-content: center !important;
`;

export const DialogHtmlDiv = styled.div`
  table {
    white-space:nowrap;
  }
`;


